import { mutate } from "swr";
import { mutateCaseNeo4j } from "./pydbcall";
import { MUTATE_CREATE, MUTATE_UPDATE, MUTATE_DELETE } from "./mutate-actions";


export default async function mutateCategoryRule(currentUserProfile, data, action=MUTATE_UPDATE) {
    
    //console.log(`entering mutateCategoryRule, action=${action}`)
    if (action != MUTATE_UPDATE && action != MUTATE_DELETE){
        throw Error(`unsupported action: ${action}`)
    }

    
    if(!currentUserProfile || !currentUserProfile.currentOrg || !currentUserProfile.currentCase || !currentUserProfile.currentUser){
        throw Error(`pass a valid current user profile to this call`)
    }

    const orgID=currentUserProfile.currentOrg.orgID
    const caseID=currentUserProfile.currentCase.caseID
    const email=currentUserProfile.currentUser.email


    //console.log(`in mutateCategoryRule, data=${JSON.stringify(data)}`)
    const delete_mutation = 'WITH datetime() as dt MATCH (o:Organization {orgID:$orgID})<-[:BELONGS_TO]-(c:Case {caseID:$caseID})-[:USES]->(rule:CategoryRule {phrase:$phrase}) DETACH DELETE rule'
    const update_mutation = 'WITH datetime() as dt MATCH (o:Organization {orgID:$orgID})<-[:BELONGS_TO]-(c:Case {caseID:$caseID})-[:USES]->(subcat:Subcategory:DefinedCategory {name:$subcategory}) MERGE (c)-[:USES]->(rule:CategoryRule {phrase:$phrase}) set rule._updateDate=dt, rule._updateUser=$currentUser MERGE (subcat)<-[r:ASSIGNS]-(rule) SET r._updateDate=dt, r._updateUser=$currentUser  WITH rule, subcat OPTIONAL MATCH (rule)-[r2:ASSIGNS]->(subcat2:Subcategory) where subcat2.name<>subcat.name DELETE r2 return rule'
    const parms = { 
        "orgID": orgID,
        "caseID": caseID, 
        "currentUser": email,
        "subcategory": data.subcategory,
        "phrase": data.phrase
        
        
    }

      //console.log(`in mutateCategoryRule, parms=${JSON.stringify(parms)}`)

    // if (action === MUTATE_UPDATE && search_before_create){
    //     //console.log('IN MUTATE SEARCH BEFORE CREATE AREA')
        
    //             const sb4create = 'MATCH (case:Case {caseName:$caseName})-[r:BELONGS_TO]->(org:Organization {orgID:$orgID}) WHERE case.caseID <> $caseID RETURN case'
    //     const sb4result = mutate(['CASE', data.caseID], mutateCaseNeo4j(update_mutation, parms,sb4create))    
    //     //console.log(JSON.stringify(sb4result))
    //     return sb4result
    // }

    
    let mutation = action==MUTATE_UPDATE?update_mutation:delete_mutation
    
    const result = mutate(['CATEGORYRULE', data.phrase], mutateCaseNeo4j(mutation, parms))
    
    //console.log(`in mutateCase: result=${JSON.stringify(result)}`)
    return result
}

export async function mutateCategoryRuleList(currentUserProfile, data) {
    data.forEach(async element => {
        let action = MUTATE_UPDATE
        if(element.action == 'DELETE'){
            action = MUTATE_DELETE
        }
        await mutateCategoryRule(currentUserProfile,element,action)
    });
}